var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuccessBig = function SvgSuccessBig(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 34L30.4444 41.1111L44.6667 26.8889M66 34C66 38.2023 65.1723 42.3635 63.5641 46.2459C61.956 50.1283 59.5989 53.6559 56.6274 56.6274C53.6559 59.5989 50.1283 61.956 46.2459 63.5641C42.3635 65.1723 38.2023 66 34 66C29.7977 66 25.6365 65.1723 21.7541 63.5641C17.8717 61.956 14.3441 59.5989 11.3726 56.6274C8.40111 53.6559 6.04401 50.1283 4.43585 46.2459C2.8277 42.3635 2 38.2023 2 34C2 25.5131 5.37142 17.3737 11.3726 11.3726C17.3737 5.37142 25.5131 2 34 2C42.4869 2 50.6263 5.37142 56.6274 11.3726C62.6286 17.3737 66 25.5131 66 34Z",
    stroke: "#00AD68",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessBig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "SuccessBig.180a2206e129708635730394ad16c5b7.svg";